"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageVm = void 0;
require("../css/app.scss");
require("../css/request-page.scss");
var smoothscroll = __importStar(require("smoothscroll-polyfill"));
var octonicaLogo_1 = __importDefault(require("./octonicaLogo"));
var getScrollTop_1 = __importDefault(require("./getScrollTop"));
require("classlist-polyfill");
require("remodal");
var ko = __importStar(require("knockout"));
var knockout_decorators_1 = require("knockout-decorators");
var jquery_1 = __importDefault(require("jquery"));
var calculateCost_1 = require("./calculateCost");
smoothscroll.polyfill();
octonicaLogo_1.default('.site-header');
window.addEventListener('scroll', function (e) {
    var currentScroll = getScrollTop_1.default();
    var classList = document.querySelector('.site-header').classList;
    if (currentScroll > 80) {
        classList.add('site-header-fixed');
    }
    else {
        classList.remove('site-header-fixed');
    }
});
var hamburger = document.querySelector('.hamburger');
hamburger.addEventListener('click', function (e) { return e.target.classList.toggle('opened'); });
var scrollTop = 0;
jquery_1.default(document).on('opening', '.remodal', function () {
    jquery_1.default('body').addClass('fix-remodal');
    var offset = jquery_1.default('body').css('padding-right');
    offset = parseFloat(offset) / 2;
    jquery_1.default('.site-header').css('left', -offset + 'px');
    scrollTop = getScrollTop_1.default();
});
jquery_1.default(document).on('closed', '.remodal', function (e) {
    jquery_1.default('body').removeClass('fix-remodal');
    jquery_1.default('.site-header').css('left', '0');
    window.scrollTo({
        top: scrollTop,
        left: 0
    });
    ko.dataFor(document.body).dialogVm = null;
});
var PageVm = /** @class */ (function () {
    function PageVm(storeKey, defaultRequestData) {
        var _this = this;
        this.defaultRequestData = defaultRequestData;
        this.formError = null;
        this.isChecking = false;
        this.modelErrors = {};
        this.userIsNotified = false;
        this.dialogVm = null;
        var form = jquery_1.default.extend({}, defaultRequestData, restoreRequest(storeKey) || {});
        this.form = form;
        this.storeKey = storeKey;
        var _loop_1 = function (p) {
            if (form.hasOwnProperty(p)) {
                knockout_decorators_1.subscribe(function () { return form[p]; }, function (prop) {
                    //console.log('changed', p, prop);
                    saveRequest(storeKey, form);
                    var errors = _this.modelErrors;
                    delete errors[p];
                    _this.modelErrors = errors;
                });
            }
        };
        for (var p in form) {
            _loop_1(p);
        }
    }
    Object.defineProperty(PageVm.prototype, "requestType", {
        get: function () {
            return this.form.requestType;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PageVm.prototype, "hasModelErrors", {
        get: function () {
            return this.modelErrors && Boolean(Object.keys(this.modelErrors).length);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PageVm.prototype, "sendButtonText", {
        get: function () {
            return this.isChecking ? 'Проверка формы...' : 'Отправить';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PageVm.prototype, "canSend", {
        get: function () {
            return !this.isChecking && this.userIsNotified;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PageVm.prototype, "calculatedCost", {
        get: function () {
            try {
                var personalAccountCount = this.form.personalAccountCount;
                if ((personalAccountCount + '') !== (parseInt(personalAccountCount, 10) + ''))
                    return 'не определена';
                var parsedAccountCount = parseInt(personalAccountCount);
                if (parsedAccountCount < 0)
                    return 'не определена';
                var cost = calculateCost_1.calculateCost(parsedAccountCount);
                if (cost == null)
                    return 'не определена';
                return cost + ' руб.';
            }
            catch (ex) {
                return 'не определена';
            }
        },
        enumerable: false,
        configurable: true
    });
    ;
    PageVm.prototype.handleModelErrors = function (r) {
        this.formError = r.formError;
        if (r.modelErrors)
            this.modelErrors = r.modelErrors;
        else
            this.modelErrors = {};
        if (Object.keys(this.modelErrors).length) {
            var errorElement = document.querySelector('.form-item-editor.error');
            if (errorElement) {
                var bb = errorElement.getBoundingClientRect();
                window.scrollBy({
                    top: bb.top - 80,
                    left: 0,
                    behavior: 'smooth'
                });
                errorElement.focus();
            }
        }
        return r;
    };
    PageVm.prototype.handleModal = function (r) {
        function createModal(html, vm) {
            var modal = document.querySelector('.modal');
            if (modal) {
                ko.cleanNode(modal);
            }
            else {
                modal = jquery_1.default('<div class="modal"></div>').appendTo(jquery_1.default('body'))[0];
            }
            modal.innerHTML = html;
            ko.applyBindings(vm, modal);
            return jquery_1.default(modal).remodal({
                closeOnOutsideClick: false,
                closeOnEscape: false
            });
        }
        function removeModal() {
            var modal = document.querySelector('.modal');
            if (modal)
                jquery_1.default(modal).remodal().destroy();
        }
        if (r.modalTemplate != null) {
            var dialogVm = this.dialogVm;
            if (dialogVm == null)
                dialogVm = new DialogVm(this);
            var modal = createModal(r.modalTemplate, dialogVm);
            if (this.dialogVm == null)
                modal.open();
            this.dialogVm = dialogVm;
            this.dialogVm.error = r.modalError;
        }
        else {
            removeModal();
            this.dialogVm = null;
        }
        return r;
    };
    PageVm.prototype.send = function () {
        var _this = this;
        jquery_1.default.ajax({
            url: '/request/sendrequest',
            type: 'POST',
            data: JSON.stringify(this.form),
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            beforeSend: function () {
                _this.isChecking = true;
            },
            complete: function () {
                _this.isChecking = false;
            },
            success: function (data) {
                _this.handleModelErrors(data);
                _this.handleModal(data);
            },
            error: function (xhr) {
                console.log(xhr);
                alert('Произошла непредвиденная ошибка. Проверьте соединение с интернетом.');
            }
        });
        return false;
    };
    PageVm.prototype.applyBindingsToCurrentPage = function () {
        var savedConfiguration = this.form.configuration;
        var savedBillingService = this.form.billingService;
        ko.applyBindings(this);
        if (!savedConfiguration)
            jquery_1.default('input:radio[name=Configuration]').prop('checked', false);
        if (!savedBillingService)
            jquery_1.default('input:radio[name=BillingService]').prop('checked', false);
        this.form.configuration = savedConfiguration;
        this.form.billingService = savedBillingService;
    };
    PageVm.prototype.clearForm = function () {
        if (confirm('Все поля формы будут очищены. Продолжить?')) {
            this.form = resetRequest(this.storeKey, this.defaultRequestData);
            //ko.dataFor(document.querySelector('body')).form.reset();
        }
    };
    __decorate([
        knockout_decorators_1.computed
    ], PageVm.prototype, "requestType", null);
    __decorate([
        knockout_decorators_1.observable({ deep: true })
    ], PageVm.prototype, "form", void 0);
    __decorate([
        knockout_decorators_1.observable
    ], PageVm.prototype, "formError", void 0);
    __decorate([
        knockout_decorators_1.observable
    ], PageVm.prototype, "isChecking", void 0);
    __decorate([
        knockout_decorators_1.observable({ deep: true })
    ], PageVm.prototype, "modelErrors", void 0);
    __decorate([
        knockout_decorators_1.observable
    ], PageVm.prototype, "userIsNotified", void 0);
    __decorate([
        knockout_decorators_1.observable
    ], PageVm.prototype, "dialogVm", void 0);
    __decorate([
        knockout_decorators_1.computed
    ], PageVm.prototype, "hasModelErrors", null);
    __decorate([
        knockout_decorators_1.computed
    ], PageVm.prototype, "sendButtonText", null);
    __decorate([
        knockout_decorators_1.computed
    ], PageVm.prototype, "canSend", null);
    __decorate([
        knockout_decorators_1.computed
    ], PageVm.prototype, "calculatedCost", null);
    return PageVm;
}());
exports.PageVm = PageVm;
window.PageVm = PageVm;
var DialogVm = /** @class */ (function () {
    function DialogVm(parent) {
        this.confirmationCode = '';
        this.error = null;
        this.isSending = false;
        this.parent = parent;
    }
    Object.defineProperty(DialogVm.prototype, "sendButtonText", {
        get: function () {
            return this.isSending ? 'Отправка...' : 'Отправить';
        },
        enumerable: false,
        configurable: true
    });
    DialogVm.prototype.send = function () {
        var _this = this;
        var requestData = this.parent.form;
        jquery_1.default.ajax({
            url: '/request/sendrequest?code=' + this.confirmationCode,
            type: 'POST',
            data: JSON.stringify(requestData),
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            beforeSend: function () {
                _this.isSending = true;
                _this.error = null;
            },
            complete: function () {
                _this.isSending = false;
            },
            success: function (data) {
                _this.error = data.modalError;
                _this.parent.handleModal(data);
            },
            error: function (xhr) {
                console.log(xhr);
                alert('Произошла непредвиденная ошибка. Проверьте соединение с интернетом.');
            }
        });
        return false;
    };
    __decorate([
        knockout_decorators_1.observable
    ], DialogVm.prototype, "confirmationCode", void 0);
    __decorate([
        knockout_decorators_1.observable
    ], DialogVm.prototype, "error", void 0);
    __decorate([
        knockout_decorators_1.observable
    ], DialogVm.prototype, "isSending", void 0);
    __decorate([
        knockout_decorators_1.computed
    ], DialogVm.prototype, "sendButtonText", null);
    return DialogVm;
}());
function saveRequest(storeKey, data) {
    localStorage.setItem(storeKey, JSON.stringify(data));
}
function restoreRequest(storeKey) {
    var data = localStorage.getItem(storeKey);
    if (data)
        return JSON.parse(data);
    return null;
}
function resetRequest(storeKey, defaultRequestData) {
    localStorage.removeItem(storeKey);
    return jquery_1.default.extend({}, defaultRequestData);
}
